<div class="modal-header">
  <h1 id="modal-title" class="modal-title">Announcements</h1>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  <myp-inline-loader [loading]="loading" height="400px" spinnerName="announcementsLoader"></myp-inline-loader>

  @if (!loading && (!features || !features.length)) {
    <div class="m-y-20">No new announcments at this time.</div>
  }
  @if (!showingAll) {
    @if (features && features[selectedIndex]) {
      <div class="text-center">
        @if (features[selectedIndex].title) {
          <h2>{{ features[selectedIndex].title }}</h2>
        }
        <span class="t-14 d-block m-b-10">{{ features[selectedIndex].date.toDate() | date }}</span>
        <div [innerHTML]="features[selectedIndex].description.en | safe: 'html'"></div>
        @if (features.length > 1) {
          <span class="gothic bold d-block text-center m-t-30">{{ selectedIndex + 1 }} of {{ features.length }}</span>
        }
      </div>
    }
  }

  @if (showingAll && !selectedAnnouncement) {
    <ul class="list-group">
      @for (ann of features; track ann) {
        <li class="list-group-item p-0 border-0 bg-transparent">
          <div role="button" aria-label="announcement">
            <myp-list-item [title]="ann.title" [subData]="[ann.date.toDate() | date]" [showImage]="false" (itemClicked)="selectAnnouncement(ann)"></myp-list-item>
          </div>
        </li>
      }
    </ul>
  }
  @if (selectedAnnouncement) {
    <div class="text-center">
      <div class="back-container gothic m-b-20">
        <button type="button" class="btn btn-transparent p-0 m-r-10" (click)="selectedAnnouncement = undefined" aria-label="back">
          <fa-icon icon="arrow-left" class="circle-icon-btn" aria-hidden="true" style="font-size: 1rem"></fa-icon>
          <span class="sr-only">back</span>
        </button>
        <h6 class="m-b-0">Announcements</h6>
      </div>
      @if (selectedAnnouncement.title) {
        <h2>{{ selectedAnnouncement.title }}</h2>
      }
      <span class="t-14 d-block m-b-10">{{ selectedAnnouncement.date.toDate() | date }}</span>
      <div [innerHTML]="selectedAnnouncement.description.en | safe: 'html'"></div>
    </div>
  }
</div>
<div class="modal-footer">
  @if (!showingAll && features && features.length > 1 && selectedIndex + 1 < features.length) {
    <button type="button" class="btn btn-primary" (click)="next()">Next</button>
  }
  <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
</div>
